import { render, staticRenderFns } from "./error-popup.component.vue?vue&type=template&id=fe4f86ce&"
import script from "./error-popup.component.ts?vue&type=script&lang=ts&"
export * from "./error-popup.component.ts?vue&type=script&lang=ts&"
import style0 from "./error-popup.component.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports